import { ResetLayerRenderer } from "../../../../api/pixijs/renderers/ResetLayerRenderer";
import { OperationRenderer, RendererName } from "../../../../api/pixijs/renderers/OperationRenderer";
import { LeafletPixiContext } from "./useLeafletPixi";
import { useTypedSelector } from "../../../../hooks/useTypedSelector";
import { useActions } from "../../../../hooks/useActions";
import { useEffect } from "react";
import logger from "@utils/logger";

const log = logger.getLogger("useResetLayer")
export default function (pixiContext: LeafletPixiContext | undefined) {
    const { bounds } = useTypedSelector(state => state.pixiSettings)
    useEffect(() => {
        if (pixiContext) {
            log.debug("Redraw reset layer...")
            const renderer = pixiContext.service.getRendererByName<ResetLayerRenderer>(RendererName.Reset)
            renderer.redraw()
        }
    }, [pixiContext, bounds])

    useEffect(() => {
        if (pixiContext) {
            log.debug("Init reset layer...")
            const renderer = pixiContext.service.getRendererByName<ResetLayerRenderer>(RendererName.Reset)
            renderer.enable()
            renderer.render()
        }
    }, [pixiContext])
}